export { createProductQuery, updateProductQuery };

const createProductQuery = `mutation($productData: CreateProductInput!) {
  createProduct(input: $productData) {
    product {
      id
      productMaster {
        images {
          id
          url(operation: crop, width: 200, height: 200)
          position
        }
      }
      variants {
        id
        images {
          id
          url(operation: crop, width: 200, height: 200)
          position
        }
      }
    }
    errors {
      code
      message
      path
    }
  }
}
`;

const updateProductQuery = `mutation($productData: UpdateProductInput!) {
  updateProduct(input: $productData){
    product {
      id
      productMaster {
        images {
          id
          url(operation: crop, width: 200, height: 200)
          position
        }
      }
      variants {
        id
        images {
          id
          url(operation: crop, width: 200, height: 200)
          position
        }
      }
    }
    errors {
      code
      message
      path
    }
  }
}
`;
